// extracted by mini-css-extract-plugin
export default {"logo":"style_logo__btODM","company":"style_company__hHKZX"};